import { Link } from 'react-router-dom';
import { videoCategories } from '@/mocks/videos';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            视频分类
          </h2>
          <Link to="/category/hot" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {videoCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 hover:bg-background-200 transition-all p-4 md:p-5 flex flex-col items-center text-center gap-3 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 hidden sm:block">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}